import { Component } from 'react'

import { InfoButton } from 'components/buttons'
import { FORM_KEY_NEW } from 'shared/constants'

import InsertCardOrderForm from 'registry/components/insert-card-order-form'

class AdminInsertCardOrderForm extends Component {
  state = {
    showForm: false,
  }

  render() {
    return this.state.showForm ? (
      <InsertCardOrderForm
        formKey={FORM_KEY_NEW}
        onHide={this.handleHideForm.bind(this)}
        onSubmitSuccess={this.handleHideForm.bind(this)}
        showWantsInsertCards={false}
      />
    ) : (
      <InfoButton onClick={() => this.setState({ showForm: true })}>
        New Order
      </InfoButton>
    )
  }

  handleHideForm() {
    this.setState({ showForm: false })
  }
}

export default AdminInsertCardOrderForm
